import { VehicleCard } from '@/components/styleguide/Card/Vehicle/VehicleCard'

export const SearchResultList = ({ items, layoutType }) =>
  items.map((item, index) => (
    <VehicleCard
      type={layoutType}
      deal={item}
      key={item.vehiclePrice.id}
      item={item}
      isPriority={index < 2}
    />
  ))
